'use client'

import BorderBeam from '@/src/components/BorderBeam'
import { PrimaryButton } from '@/src/components/Buttons'

const REPORT_URL = '/reports/ai-agent-monetization-guide.pdf'

interface DownloadReportButtonProps {
  label?: string
  source?: string
}

const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({
  label = 'Download report (PDF)',
  source,
}) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        borderRadius: 0,
      }}
    >
      <PrimaryButton
        data-download-source={source}
        onClick={() => {
          const link = document.createElement('a')
          link.href = REPORT_URL
          link.download = ''
          link.click()
        }}
      >
        {label}
      </PrimaryButton>
      <BorderBeam />
    </span>
  )
}

export default DownloadReportButton
